import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../apollo/client';
import { GET_ATHLETE_DASHBOARD } from '../../apollo/queries/athlete';

export const fetchAthleteDashboard = createAsyncThunk(
  'athlete/fetchDashboard',
  async (_, thunkAPI) => {
    try {
      const { data } = await client.query({
        query: GET_ATHLETE_DASHBOARD,
        fetchPolicy: 'no-cache'
      });
      return data.getAthleteDashboard;
    } catch (err) {
      console.error("❌ Dashboard Fetch Error:", err);
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);


const athleteSlice = createSlice({
  name: 'athlete',
  initialState: {
    profile: null,
    assessments: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearAthleteState(state) {
      state.profile = null;
      state.assessments = [];
      state.loading = false;
      state.error = null;
    },
    updateUnlockedLevels(state, action) {
      const { sport, level } = action.payload;
      if (!state.profile) return;
    
      if (!state.profile.unlockedGameIQLevels) {
        state.profile.unlockedGameIQLevels = [];
      }
    
      const existing = state.profile.unlockedGameIQLevels.find(entry => entry.sport === sport);
    
      if (existing) {
        if (!existing.levels.includes(level)) {
          existing.levels.push(level);
        }
      } else {
        state.profile.unlockedGameIQLevels.push({ sport, levels: [level] });
      }
    },
    addAssessment(state, action) {
      state.assessments.unshift(action.payload);
    },
    removeCoach(state, action) {
      const coachId = action.payload;
      if (state.profile?.coaches) {
        state.profile.coaches = state.profile.coaches.filter(
          (coach) => coach._id !== coachId
        );
      }
    },
    updateProfile(state, action) {
      if (state.profile) {
        Object.assign(state.profile, action.payload);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAthleteDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAthleteDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload.athlete;
        state.assessments = action.payload.assessments;
      })
      .addCase(fetchAthleteDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearAthleteState, updateUnlockedLevels, addAssessment, removeCoach, updateProfile } = athleteSlice.actions;
export default athleteSlice.reducer;